// extracted by mini-css-extract-plugin
export var alignCenter = "_9d-d";
export var bannerShown = "_9d-6";
export var buttonContent = "_9d-0";
export var cardList = "_9d-1";
export var centerContent = "_9d-2";
export var chevron = "_9d-3";
export var closePanelButton = "_9d-k";
export var conversationContextContainer = "_9d-l";
export var conversationDetailContainer = "_9d-4";
export var detailWrapper = "_9d-7";
export var dropdownButton = "_9d-e";
export var dropdownTitle = "_9d-9";
export var fullHeight = "_9d-5";
export var hidden = "_9d-a";
export var icon = "_9d-b";
export var mergeSuggestionWrapper = "_9d-m";
export var panel = "_9d-i";
export var portalButtonsWrapper = "_9d-c";
export var right = "_9d-j";
export var tableSummaryContainer = "_9d-8";
export var tableSummaryHeader = "_9d-g";
export var threeDotsButton = "_9d-f";
export var wide = "_9d-h";